import React, { useState } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components"
import { GrClose } from "react-icons/gr";
import Popprogress from "./Popprograss";
export default function Sidepop ({closeMode}){
   const [popactive, setPop] = useState(1)

   const toggleClas = (index) =>{
       setPop(index);
   }
    return(
        <Div>
        <div className="sidepop">
            <div className="popClose">
                <GrClose  onClick={()=> closeMode(false)} />
            </div>
            <div className="sidepop-btn">
                <Link onClick={() => toggleClas(3)} className={popactive === 3 ? "btnActive" : null } to="#">A-Z</Link>
                <Link onClick={() => toggleClas(2)}  className={popactive === 2 ? "btnActive" : null } to="#">Active</Link>
                <Link  onClick={() => toggleClas(1)} className={popactive === 1 ? "btnActive" : null }  to="#">Product</Link>
            </div>
            <div  className={popactive === 1 ? "sidepop-description popActive" : "sidepop-description"}>
                <div className="side-title">
                    TBD Tango 2/Top
                </div>
                <div className="prograss-bar ">
              
              <div className="pro-br progres-bar3">
                <Popprogress bel={"Beltjig 5"} done={14} />
              </div>
              <div className="pro-br progres-bar3">
                <Popprogress bel={"Beltjig 6"} done={0} />
              </div>
            </div>
            <div className="side-title title2">
                   Crossfire Diversity NanoR
                </div>
                <div className="prograss-bar ">
              
              <div className="pro-br progres-bar3">
                <Popprogress bel={"Beltjig 1"} done={2} />
              </div>
             
            </div>
            <div className="side-title title2">
                  No Products Selected
                </div>
                <div className="prograss-bar ">
              
              <div className="pro-br progres-bar3">
                <Popprogress bel={"Beltjig 3"} done={0} />
              </div>
             
            </div>
            
            </div>

            <div  className={popactive === 2 ? "sidepop-description popActive" : "sidepop-description"}>
                <div className="side-title">
                    TBD Tango 2/Top
                </div>
                <div className="prograss-bar ">
              
              <div className="pro-br progres-bar3">
                <Popprogress bel={"Beltjig 5"} done={13} />
              </div>
              <div className="pro-br progres-bar3">
                <Popprogress bel={"Beltjig 6"} done={2} />
              </div>
            </div>
            <div className="side-title title2">
                   Crossfire Diversity NanoR
                </div>
                <div className="prograss-bar ">
              
              <div className="pro-br progres-bar3">
                <Popprogress bel={"Beltjig 1"} done={10} />
              </div>
             
            </div>
            <div className="side-title title2">
                  No Products Selected
                </div>
                <div className="prograss-bar ">
              
              <div className="pro-br progres-bar3">
                <Popprogress bel={"Beltjig 3"} done={0} />
              </div>
             
            </div>
            
            </div>
            <div  className={popactive === 3 ? "sidepop-description popActive" : "sidepop-description"}>
                <div className="side-title">
                    TBD Tango 2/Top
                </div>
                <div className="prograss-bar ">
              
              <div className="pro-br progres-bar3">
                <Popprogress bel={"Beltjig 5"} done={16} />
              </div>
              <div className="pro-br progres-bar3">
                <Popprogress bel={"Beltjig 6"} done={3} />
              </div>
            </div>
            <div className="side-title title2">
                   Crossfire Diversity NanoR
                </div>
                <div className="prograss-bar ">
              
              <div className="pro-br progres-bar3">
                <Popprogress bel={"Beltjig 1"} done={5} />
              </div>
             
            </div>
            <div className="side-title title2">
                  No Products Selected
                </div>
                <div className="prograss-bar ">
              
              <div className="pro-br progres-bar3">
                <Popprogress bel={"Beltjig 3"} done={0} />
              </div>
             
            </div>
            
            </div>
        </div>
        </Div>
    )
}

const Div = styled.div`
  position: fixed;
	width:300px;
	height: 100vh;
	top: 0;
	left: 0;
	background-color: rgba(0, 0, 0, .8);
    overflow: hidden;
    z-index: 1111;
    color: #fff !important;
    @media (max-width:767px){
      width: 220px;
    }
    .sidepop{
        padding: 10px;
        background-color: #7b7be0;
        position: absolute;
     left: 50%;
     top: 50%;
     transform: translate(-50%, -50%); 
     border-radius: 8px;
     box-sizing: border-box;
     .popClose{
         position: absolute;
         right: 5px;
         top: 5px;
         svg{
           cursor: pointer;
             float: right;
             color: #fff !important;
             path{
                 stroke: #fff !important;
             }
         }
     }
        .sidepop-btn{
            display: flex;
            align-items: center;
            background-color: #10B981;
            border-radius: 10px;
            margin-top:15px;
          .btnActive{
            background-color: #047857;
          }
            a{
                padding: 10px;
                background-color: transparent;
                width: 80px;
                text-align: center;
                color: #fff;
                font-weight: bold;
                @media (max-width:767px){
      width: 60px;
      font-size: 12px;
    }
                &:hover{
                    background-color: #047857;
                }
                &:nth-child(2){
                border-right:1px solid  #a78181;
                border-left:1px solid  #a78181;
            }

            &:nth-child(1){
                border-bottom-left-radius: 10px;
                border-top-left-radius: 10px;
               &:hover{
                border-bottom-left-radius: 10px;
                border-top-left-radius: 10px;
               }
            }
            &:nth-child(3){
                border-top-right-radius:10px;
                border-bottom-right-radius:10px;
               &:hover{
                border-top-right-radius:10px;
                border-bottom-right-radius:10px;
               }
            }
            }
        }
        .sidepop-description{
            display: none;
        .side-title{
            padding-top: 20px;
            padding-bottom: 0px;
            @media (max-width:767px){
              font-size: 15px;
            }
        }
        .title2{
            padding-top: 0px;
        }
    }
    .popActive{
        display: block;
    }
    }
`;